import { component } from "picoapp";
import { currencySymbol, formatMoney } from "../../../scripts/lib/currency";

const getOffsetValue = () => {
  const announcementBarHeight =
    document
      .querySelector("#shopify-section-tbsp-announcement-bar")
      ?.getBoundingClientRect?.().height ?? 0;
  const topNavigationHeight =
    document
      .querySelector("#shopify-section-tbsp-navigation")
      ?.getBoundingClientRect?.().height ?? 0;

  return announcementBarHeight + topNavigationHeight;
};

export const stickyProductBar = component((node: HTMLDivElement, context) => {
  const primaryAddToCartContainer: HTMLDivElement = node.closest(
    "#primary-add-to-cart"
  );

  const rootElement: HTMLElement = node.closest("#root");

  if (!rootElement) {
    return;
  }

  // Make the bar a child of our root element
  // This ensures sticky positioning in the correct hierarchy
  rootElement.prepend(node);
  node.classList.replace("hidden", "sticky");

  if (!primaryAddToCartContainer) {
    return;
  }

  const offset = getOffsetValue();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (
          !entry.isIntersecting &&
          entry.boundingClientRect.top < entry.rootBounds.bottom
        ) {
          node.classList.replace("-translate-y-full", "translate-y-0");
          node.classList.replace("shadow-none", "shadow-product-bar");
        } else {
          node.classList.replace("translate-y-0", "-translate-y-full");
          node.classList.replace("shadow-product-bar", "shadow-none");
        }
      });
    },
    {
      rootMargin: `-${offset}px 0px 0px`,
    }
  );

  observer.observe(primaryAddToCartContainer);

  const updateVariantPrice = (variant) => {
    const priceElement = node.querySelector("[data-price]");
    const compareAtPriceElement = node.querySelector("[data-compare-at-price]");
    const currency = currencySymbol();

    if (priceElement) {
      const priceTextNode = priceElement.querySelector(
        "[data-tbsp-component='text']"
      );

      priceTextNode.textContent = variant.price
        ? `${currency}${formatMoney(
            variant.price,
            "{{ amount_no_trailing_zeroes }}",
            false
          )}`
        : "";

      if (variant.compare_at_price) {
        priceTextNode.classList.add("text-interactive-brick");
      } else {
        priceTextNode.classList.remove("text-interactive-brick");
      }
    }

    if (compareAtPriceElement) {
      const compareAtPriceTextNode = compareAtPriceElement.querySelector(
        "[data-tbsp-component='text']"
      );
      compareAtPriceTextNode.textContent = variant.compare_at_price
        ? `${currency}${formatMoney(
            variant.compare_at_price,
            "{{ amount_no_trailing_zeroes }}",
            false
          )}`
        : "";
    }
  };

  context.on("tbsp:variant-selected", async (variant) => {
    node.dataset.productCurrentVariantId = variant.id;
    updateVariantPrice(variant);
  });

  return (node: HTMLButtonElement) => {
    observer.disconnect();
  };
});
